import { Article, Category } from "@/lib/content-types";

// Sample nieuws categories
export const nieuwsCategories: Category[] = [
  {
    key: "trends",
    label: "Trends",
    description: "Markttrends en ontwikkelingen",
    color: "bg-blue-500"
  },
  {
    key: "elektra-smarthome",
    label: "Elektra & Smarthome",
    description: "Elektrische installaties en domotica",
    color: "bg-orange-500"
  },
  {
    key: "renovatie",
    label: "Renovatie",
    description: "Duurzame verbouwing en isolatie",
    color: "bg-green-500"
  },
  {
    key: "zonne-energie",
    label: "Zonne-energie",
    description: "Zonnepanelen en energieopwekking",
    color: "bg-yellow-500"
  },
  {
    key: "verwarming",
    label: "Verwarming",
    description: "Warmtepompen en energiezuinige verwarming",
    color: "bg-blue-500"
  }
];

// Sample blog categories
export const blogCategories: Category[] = [
  {
    key: "thuisbatterijen",
    label: "Thuisbatterijen",
    description: "Energieopslag voor thuis",
    color: "bg-green-500"
  },
  {
    key: "warmtepompen",
    label: "Warmtepompen",
    description: "Duurzame verwarming",
    color: "bg-blue-500"
  },
  {
    key: "zonnepanelen",
    label: "Zonnepanelen",
    description: "Zonne-energie oplossingen",
    color: "bg-yellow-500"
  },
  {
    key: "subsidies",
    label: "Subsidies",
    description: "Financiële steun",
    color: "bg-purple-500"
  }
];

// Sample nieuws articles
export const nieuwsArticles: Article[] = [
  {
    id: 1,
    slug: "elektrische-installaties-slimme-woningtechniek",
    title: "Elektrische installaties en slimme woningtechniek",
    excerpt: "Ontdek hoe SOL-VI met moderne elektrische installaties en domotica het wooncomfort verhoogt én energiekosten verlaagt. Gratis advies en offerte!",
    content: `Een betrouwbare en veilige elektrische installatie is de basis van een comfortabel huis. SOL-VI installeert of vernieuwt bedrading, schakelmateriaal en meterkast volgens de nieuwste normen. Zo voorkom je gevaarlijke kortsluitingen en blijft je woning beschermd tegen brand en stroomschokken.

**Voordelen van moderne elektra en domotica:**

**Veiligheid**: Een erkend elektricien voorkomt kortsluiting en hoge spanningsschommelingen. Met een goedgekeurde meterkast en correcte aarding voldoe je aan de veiligheidsnormen en bescherm je je gezin.

**Energiebesparing**: LED-verlichting verbruikt tot 80–90% minder energie dan traditionele lampen. Slimme thermostaten en sensoren schakelen verwarming en verlichting automatisch uit wanneer je weg bent, wat de energierekening verlaagt.

**Comfort**: Met één app bedien je verlichting, verwarming en alarmsysteem. Zo kun je lampen dimmen en de verwarming alvast aanzetten voordat je thuiskomt. Automatisering (bijvoorbeeld Loxone Smart Home) schakelt lichten uit bij daglicht en voorkomt onnodig verbruik.

**Beveiliging**: Moderne installaties integreren slimme rook- en CO₂-melders en bewegingssensoren. Bij brand of inbraak krijg je direct een melding op je telefoon, waardoor je sneller kunt ingrijpen.

**Toekomstgericht**: De nieuwe bedrading is klaar voor uitbreiding. SOL-VI kan eenvoudig elektrische laadpalen voor je EV, zonnepanelen of een warmtepomp aansluiten. Zo ben je voorbereid op elke duurzame upgrade.

Steeds meer Nederlanders kiezen voor een slimme woning. Ruim 59% van de huishoudens heeft inmiddels minstens één smart-homeproduct in huis. Geïntegreerde systemen (domotica) laten apparaten samenwerken voor extra gemak en duurzaamheid.`,
    category: "Elektra & Smarthome",
    date: "2025-08-30",
    readTime: 5,
    tags: ["elektra", "domotica", "smart home", "veiligheid", "LED", "thermostaat"],
    keywords: ["elektrische installatie", "domotica", "smart home", "LED verlichting", "Elst", "Gelderland"],
    author: "SOL-VI Team",
    featured: true
  },
  {
    id: 2,
    slug: "duurzame-renovatie-energiezuinig-verbouwen",
    title: "Duurzame renovatie: energiezuinig verbouwen",
    excerpt: "Laat SOL-VI je helpen bij een duurzame verbouwing. Lees hoe isolatie, slimme installaties en subsidies je huis energiezuiniger maken. Vraag vrijblijvend advies of offerte aan!",
    content: `Een goed geïsoleerde en energiezuinige woning is comfortabeler én goedkoper in gebruik. Bij een duurzame renovatie focus je op maatregelen zoals dakisolatie, spouwmuurisolatie en HR++ glas om warmteverlies tegen te gaan. Ook energiezuinige installaties zoals zonnepanelen, warmtepompen en moderne HR-ketels spelen een belangrijke rol.

**Belangrijke maatregelen:**

**Isolatie**: Voor dak-, vloer- en muurisolatie en hoogwaardig glas (HR++/Triple) geldt subsidie via de ISDE-regeling. Goede isolatie bespaart veel stookkosten en zorgt voor een comfortabel binnenklimaat.

**Biobased isolatie**: Natuurlijke materialen (vlas, houtvezel, schapenwol) ontvangen extra subsidie. Deze duurzame isolatiematerialen zijn beter voor milieu en gezondheid.

**Duurzame installaties**: Vervang ouderwetse verwarming door een warmtepomp of moderne HR-ketel en installeer zonnepanelen. Zulke systemen wekken energie op en verminderen je gas- en stroomkosten aanzienlijk.

**Ventilatie en luchtkwaliteit**: Een gebalanceerd ventilatiesysteem voert vocht en vervuiling af zonder veel warmteverlies. Zo verbeter je de luchtkwaliteit en voorkom je schimmel, met minimale energiekosten.

**Waarde en comfort**: Een energiezuinig huis krijgt een beter energielabel en stijgt in waarde. Duurzame investeringen kunnen tot 75–100% van de kosten terugverdienen in woningwaarde. Tegelijk geniet je van meer comfort (minder tocht, stabielere temperatuur).

Elke goed uitgevoerde isolatiemaatregel levert al snel tientallen euro's besparing per maand op. Investeren in energiebesparing betaalt zich dubbel terug: je krijgt lagere vaste lasten én een comfortabeler huis.`,
    category: "Renovatie",
    date: "2025-08-29",
    readTime: 6,
    tags: ["isolatie", "renovatie", "ISDE", "energielabel", "HR glas", "ventilatie"],
    keywords: ["duurzame renovatie", "isolatie", "energiezuinig verbouwen", "ISDE subsidie", "Elst"],
    author: "SOL-VI Team"
  },
  {
    id: 3,
    slug: "zonnepanelen-investeren-duurzame-energie",
    title: "Zonnepanelen: investeren in duurzame energie",
    excerpt: "Ontdek hoe zonnepanelen je energierekening verlagen en je huis verduurzaamt. Lees over voordelen, subsidies en terugverdientijd, en vraag vrijblijvend een offerte aan bij SOL-VI.",
    content: `Met zonnepanelen op je dak wek je je eigen stroom op en verlaag je flink je energiekosten. Zonne-energie maakt je minder afhankelijk van schommelende energieprijzen en levert direct een duurzame bijdrage aan het milieu. In 2025 zijn zonnepanelen extra aantrekkelijk: moderne zonnepanelen zijn bovendien onderhoudsarm en gaan jarenlang mee.

**Belangrijke voordelen:**

**Lagere energierekening**: Je gebruikt stroom die je zelf opwekt, dus je hoeft minder in te kopen van het net. Bij hoge stroomprijzen levert dit flinke besparingen op.

**Financiële voordelen**: Tegenwoordig betaal je geen btw bij aanschaf van zonnepanelen. Bovendien levert de salderingsregeling (nu nog 70% vergoeding) tijdelijk extra rendement op.

**Snelle terugverdientijd**: Dankzij dalende aanschafkosten en hoge opbrengst kost het gemiddeld slechts 5–10 jaar voordat je investering is terugverdiend. Daarna levert het systeem nog 15–20 jaar gratis stroom op.

**Rendement**: Moderne panelen (bijv. 300 Wp per stuk) kunnen 250–300 kWh per jaar opleveren bij optimale ligging. Zo wek je een groot deel van je stroom zelf op – goed voor honderden euro's besparing per jaar.

**Duurzaamheid**: Zonnepanelen verlagen direct je CO₂-uitstoot en dragen bij aan een groenere toekomst. Ze gaan gemiddeld 25–30 jaar mee met weinig onderhoud.

**Waardevermeerdering**: Een woning met zonnepanelen krijgt vaak een beter energielabel en is aantrekkelijker bij verkoop. De investering rendeert dus zowel op de energierekening als in de waarde van je huis.

Bovendien geldt momenteel nog een 70%-tarief voor teruggeleverde stroom via de salderingsregeling. Vanaf 2027 wordt deze regeling stapsgewijs afgeschaft. Dat betekent: profiteer nu nog maximaal van de vergoeding voor jouw zonnestroom en sla je slag met een snelle terugverdientijd.`,
    category: "Zonne-energie",
    date: "2025-08-25",
    readTime: 5,
    tags: ["zonnepanelen", "zonne-energie", "saldering", "energierekening", "duurzaam", "btw"],
    keywords: ["zonnepanelen", "zonne-energie", "energierekening", "salderingsregeling", "Elst", "Gelderland"],
    author: "SOL-VI Team"
  },
  {
    id: 4,
    slug: "warmtepompen-energiezuinige-verwarming",
    title: "Warmtepompen en energiezuinige verwarming",
    excerpt: "Overweeg je een warmtepomp? Lees over besparing, subsidies en comfort van hybride of all-electric verwarming. Vraag advies of offerte aan bij SOL-VI.",
    content: `Steeds meer huiseigenaren kiezen voor een warmtepomp om hun huis te verwarmen. Een warmtepomp gebruikt elektriciteit om warmte uit de omgeving (lucht, bodem of grondwater) te halen en is daardoor zeer efficiënt. In vergelijking met een traditionele cv-ketel bespaar je met een warmtepomp tot wel 60–80% op gasverbruik en CO₂-uitstoot.

**Voordelen van een warmtepomp:**

**Energiebesparing**: Door de hoge efficiëntie (COP) en gratis energie uit de lucht of grond heb je veel minder gas nodig. Bij oudere huizen kan een hybride warmtepomp je gasverbruik soms met wel 80% verminderen.

**Subsidies**: De overheid biedt via de ISDE-regeling flink wat subsidie op warmtepompen. Bijvoorbeeld: voor een volwaardige 8 kW warmtepomp met energielabel A+++ ontvang je €3.025 subsidie. Ook kun je vaak de btw (21%) op de installatie terugvragen.

**Duurzaamheid**: Geen verbranding van fossiele brandstoffen betekent een veel lagere CO₂-uitstoot. Zeker in combinatie met zonnepanelen kun je je huis bijna volledig duurzaam verwarmen.

**Waardevermeerdering**: Een duurzame verwarmingsinstallatie verbetert het energielabel en de verkoopwaarde van je woning. Onderzoek toont dat woningen met een warmtepomp tot wel 11% meer waard kunnen zijn.

**Comfort**: Een warmtepomp levert constant comfortabele warmte, zonder grote temperatuurschommelingen. Ook is onderhoud relatief eenvoudig (geen branders of gasleidingen).

**Flexibiliteit**: SOL-VI installeert zowel hybride als volledig elektrische warmtepompen. Een hybride warmtepomp werkt samen met je cv-ketel voor extra efficiëntie, terwijl een volledig elektrische (all-electric) warmtepomp de ketel volledig vervangt.

Elke geïnstalleerde warmtepomp begint vrijwel direct winst op te leveren: binnen enkele jaren heb je de investering vaak terugverdiend dankzij lagere energiekosten en subsidies. Een slimme thermostaat kan je besparing verder vergroten door de verwarming automatisch te regelen op basis van aanwezigheid.`,
    category: "Verwarming",
    date: "2025-08-20",
    readTime: 6,
    tags: ["warmtepomp", "verwarming", "ISDE", "hybride", "all-electric", "energiebesparing"],
    keywords: ["warmtepomp", "energiezuinige verwarming", "ISDE subsidie", "hybride warmtepomp", "Elst"],
    author: "SOL-VI Team"
  }
];

// Sample blog articles  
export const blogArticles: Article[] = [
  {
    id: 1,
    slug: "thuisbatterijen-doorbraak-2025",
    title: "Waarom thuisbatterijen in 2025 doorbreken",
    excerpt: "2025 wordt het doorbraakjaar voor thuisbatterijen. Ontdek waarom energieopslag nu interessant wordt.",
    content: `2025 wordt het doorbraakjaar voor thuisbatterijen in Nederland.

**De nieuwe realiteit: van saldering naar zelfvoorzienendheid**

De salderingsregeling verdwijnt geleidelijk (vanaf 2027 voor nieuwe installaties), maar dat betekent niet dat zonnepanelen minder interessant worden. Integendeel: de focus verschuift naar maximaal eigenverbruik en slimme energiesturing.

Een gemiddeld huishouden met 12 zonnepanelen (4.200 Wp) kan zonder batterij slechts 35% van de opgewekte stroom direct gebruiken. Met een 10 kWh thuisbatterij stijgt dit naar 65-75%.

**Concrete businesscase: rekenvoorbeeld 2025**

*Situatie: Gezin met 4.200 Wp zonnepanelen*

- **Jaarproductie:** 3.800 kWh
- **Huishoudelijk verbruik:** 3.500 kWh/jaar  
- **Zonder batterij - eigenverbruik:** 35% (1.330 kWh)
- **Met 10 kWh batterij - eigenverbruik:** 70% (2.660 kWh)
- **Extra besparing per jaar:** 1.330 kWh × €0,30 = **€399**
- **Terugverdientijd batterij (€8.500):** 12 jaar met dynamisch contract`,
    category: "Thuisbatterijen",
    date: "2025-06-28",
    readTime: 6,
    tags: ["thuisbatterij", "energieopslag", "zonnepanelen", "saldering"],
    keywords: ["thuisbatterij", "energieopslag", "saldering", "zonnepanelen"],
    author: "SOL-VI Energie-experts",
    featured: true
  },
  {
    id: 2,
    slug: "zonnepanelen-beginners-gids-2025",
    title: "Zonnepanelen voor Beginners: De Ultieme Gids voor 2025",
    excerpt: "Overweeg je zonnepanelen, maar zie je door de bomen het bos niet meer? Deze complete gids neemt je stap voor stap mee door alles wat je moet weten.",
    content: `Overweeg je zonnepanelen, maar zie je door de bomen het bos niet meer? Geen zorgen. Zonnepanelen zijn een slimme investering in je huis en de toekomst, en de basis is eenvoudiger dan je denkt. In deze gids nemen we je stap voor stap mee door alles wat je moet weten voordat je de overstap maakt.

**Hoe werken zonnepanelen precies?**

Heel simpel gezegd: zonnepanelen zetten zonlicht om in elektriciteit. Dit gebeurt in de zonnecellen van het paneel.

**Zonlicht raakt het paneel:** Fotonen (lichtdeeltjes) uit zonlicht botsen op de zonnecellen.

**Elektronen komen in beweging:** Deze botsing zorgt ervoor dat elektronen in de zonnecel loskomen en gaan bewegen. Deze beweging is in feite elektrische stroom. Dit heet gelijkstroom.

**De omvormer doet zijn werk:** De opgewekte gelijkstroom is nog niet geschikt voor je apparaten thuis. Een omvormer zet de gelijkstroom om in wisselstroom, dezelfde stroom die uit je stopcontact komt.

**Stroom voor je huis:** De wisselstroom gaat naar je meterkast en wordt direct gebruikt door je koelkast, wasmachine, verlichting en andere apparaten.

Produceer je op een zonnige dag meer stroom dan je verbruikt? Dan lever je dit overschot terug aan het elektriciteitsnet.

**De voordelen op een rij**

Waarom zou je investeren in zonnepanelen? De voordelen zijn duidelijk:

**Lagere energierekening:** Je wekt je eigen stroom op, dus je hoeft minder (of zelfs geen) stroom meer te kopen van je energieleverancier. Dit scheelt aanzienlijk in de maandelijkse kosten.

**Goed voor het milieu:** Zonne-energie is 100% groen. Je vermindert je CO2-uitstoot en draagt direct bij aan een duurzamere wereld.

**Waardeverhoging van je woning:** Een huis met zonnepanelen heeft vaak een beter energielabel en is aantrekkelijker voor potentiële kopers.

**Onafhankelijkheid:** Je bent minder afhankelijk van de stijgende en schommelende energieprijzen.

**Kosten en terugverdientijd: is het de investering waard?**

De kosten van een zonnepanelensysteem hangen af van het aantal panelen, het type omvormer en de installatie. Gemiddeld kun je rekenen op een bedrag tussen de €4.000 en €7.000 voor een gemiddeld huishouden.

De terugverdientijd is de periode die nodig is om de investering terug te verdienen met de besparing op je energierekening. Momenteel ligt deze tijd vaak tussen de 6 en 8 jaar. Aangezien zonnepanelen een levensduur hebben van minstens 25 jaar, geniet je dus nog vele jaren van gratis stroom.

**De Salderingsregeling in 2025 en verder**

De salderingsregeling is een belangrijke regeling die zonnepanelen extra aantrekkelijk maakt. Het betekent dat de stroom die je teruglevert aan het net, wordt weggestreept tegen de stroom die je op andere momenten verbruikt. Hoewel er plannen zijn om deze regeling in de toekomst af te bouwen, blijft het voorlopig een groot voordeel. Ook zonder volledige saldering blijven zonnepanelen een zeer rendabele investering, zeker in combinatie met een thuisbatterij.

**Klaar voor de volgende stap?**

Ben je na het lezen van deze gids enthousiast geworden? Het team van Sol-vi.nl staat klaar om je te helpen. Vraag vrijblijvend een adviesgesprek aan en ontdek wat zonnepanelen voor jouw situatie kunnen betekenen.`,
    category: "zonnepanelen",
    date: "2025-08-30",
    readTime: 8,
    tags: ["zonnepanelen", "beginners", "salderingsregeling", "energierekening", "terugverdientijd"],
    keywords: ["zonnepanelen beginners", "zonnepanelen gids", "salderingsregeling", "energierekening", "Elst", "Gelderland"],
    author: "SOL-VI Team"
  },
  {
    id: 3,
    slug: "omvormer-kiezen-juiste-keuze",
    title: "De Motor van je Zonnepanelen: Hoe Kies je de Juiste Omvormer?",
    excerpt: "De omvormer is de onzichtbare held van je zonne-installatie. Ontdek het verschil tussen stringomvormers en micro-omvormers en maak de juiste keuze.",
    content: `Wanneer mensen aan zonnepanelen denken, zien ze de panelen op het dak voor zich. Logisch, want die zijn het meest zichtbaar. Maar de onzichtbare held van je zonne-installatie is minstens zo belangrijk: de omvormer. Dit apparaat is de 'motor' van je systeem. Het zet de opgewekte zonne-energie om in bruikbare stroom voor je huis. Maar welke omvormer is de beste keuze voor jou?

**Wat doet een omvormer?**

Zonnepanelen produceren 'gelijkstroom' (DC). Je huishoudelijke apparaten, van je tv tot de waterkoker, werken echter op 'wisselstroom' (AC). De omvormer is het cruciale onderdeel dat deze gelijkstroom omzet in wisselstroom. Zonder een goede omvormer heb je dus niets aan de opgewekte energie.

Daarnaast monitort de omvormer de prestaties van je zonnepanelen. Via een app op je telefoon kun je precies zien hoeveel energie je opwekt en wat de status is van je systeem.

**Twee hoofdsoorten: Stringomvormers vs. Micro-omvormers**

De keuze voor een omvormer komt meestal neer op twee opties: een centrale stringomvormer of een systeem met micro-omvormers.

**1. De Stringomvormer**

Dit is de traditionele en meest gebruikte oplossing. Alle zonnepanelen worden in een of meerdere 'strings' (series) aan elkaar gekoppeld en aangesloten op één centrale omvormer. Deze hangt meestal op zolder of in de garage.

**Voordelen:**
- Lagere aanschafkosten.
- Bewezen en betrouwbare technologie.
- Makkelijker te onderhouden omdat er maar één apparaat is.

**Nadelen:**
- De hele string presteert zo goed als het zwakste paneel. Ligt één paneel deels in de schaduw of is het vervuild, dan heeft dit invloed op de opbrengst van alle andere panelen in die string.
- Minder flexibel bij complexe daken met verschillende hellingshoeken of oriëntaties.

**Ideaal voor:** Daken zonder schaduw, waar alle panelen dezelfde kant op liggen.

**2. Micro-omvormers**

Bij dit systeem heeft elk zonnepaneel zijn eigen kleine omvormer, direct achterop het paneel gemonteerd. Elk paneel werkt dus als een onafhankelijke energiecentrale. Bekende merken zijn bijvoorbeeld Enphase en SolarEdge (die met power optimizers werkt, wat een vergelijkbaar resultaat geeft).

**Voordelen:**
- Maximale opbrengst per paneel: Schaduw op één paneel heeft geen invloed op de rest van de panelen.
- Uitgebreide monitoring: Je kunt de prestaties van elk individueel paneel volgen.
- Flexibiliteit en schaalbaarheid: Ideaal voor complexe daken en makkelijk uit te breiden in de toekomst.
- Veiligheid: Werkt met een lagere spanning op het dak.

**Nadelen:**
- Hogere investeringskosten.
- Onderhoud kan complexer zijn omdat de omvormers op het dak liggen.

**Ideaal voor:** Daken met schaduwval (van een dakkapel, boom of schoorsteen), daken met verschillende oriëntaties, of voor wie de maximale prestatie en de meest gedetailleerde monitoring wenst.

**Welke keuze is de juiste voor jou?**

De beste omvormer hangt volledig af van jouw dak en je wensen. Heb je een perfect, schaduwvrij dak op het zuiden? Dan is een stringomvormer een uitstekende en kostenefficiënte keuze. Heb je te maken met schaduw of een complex dak? Dan haal je op de lange termijn meer rendement uit een systeem met micro-omvormers.

Bij Sol-vi.nl kijken we altijd naar jouw unieke situatie. Onze experts analyseren je dak, bespreken je wensen en geven een eerlijk advies over het systeem dat voor jou de hoogste opbrengst en de beste waarde biedt. Neem contact op voor een persoonlijk advies.`,
    category: "zonnepanelen",
    date: "2025-08-29",
    readTime: 7,
    tags: ["omvormer", "stringomvormer", "micro-omvormer", "zonnepanelen", "monitoring"],
    keywords: ["omvormer zonnepanelen", "stringomvormer", "micro-omvormer", "zonnepanelen omvormer", "Elst"],
    author: "SOL-VI Team"
  },
  {
    id: 4,
    slug: "meterkast-checklist-zonnepanelen",
    title: "Is Jouw Meterkast Klaar voor Zonnepanelen? Een Checklist",
    excerpt: "Je meterkast is het zenuwcentrum van je elektrische installatie. Controleer met deze checklist of jouw meterkast klaar is voor zonnepanelen.",
    content: `Je hebt de knoop doorgehakt: er komen zonnepanelen op je dak. Een uitstekende beslissing! De installateur komt langs en de panelen liggen er zo op. Maar dan... de meterkast. Dit is het zenuwcentrum van je elektrische installatie en een cruciaal onderdeel voor een veilige en goed functionerende zonne-installatie. Is jouw meterkast er wel klaar voor? Met deze checklist weet je waar je op moet letten.

**Waarom is de meterkast zo belangrijk?**

De meterkast is het punt waar de opgewekte zonnestroom je huis binnenkomt en wordt verdeeld. Het is ook de plek die de veiligheid van het hele systeem waarborgt. Een zonnepaneleninstallatie moet op een eigen, aparte groep worden aangesloten om overbelasting van het netwerk te voorkomen.

**De Checklist: 4 cruciale punten**

Controleer deze vier punten in je meterkast om een idee te krijgen of er aanpassingen nodig zijn.

**1. Heb je een moderne stoppenkast met automaten?**

Veel oudere huizen hebben nog een traditionele stoppenkast met smeltzekeringen (de 'stoppen' die je moest vervangen). Hoewel het technisch mogelijk is om hier een zonnepanelensysteem op aan te sluiten, is het sterk aan te raden om de meterkast te moderniseren. Moderne groepen-kasten met installatieautomaten (schakelaars) zijn veiliger en gebruiksvriendelijker. De meeste installateurs zullen dit als voorwaarde stellen.

**2. Is er een hoofdschakelaar aanwezig?**

Een hoofdschakelaar is een schakelaar waarmee je in één keer alle stroom in huis kunt uitschakelen. Sinds 2005 is dit verplicht in nieuwe huizen en bij grote aanpassingen aan de meterkast. Voor het aansluiten van zonnepanelen is een hoofdschakelaar essentieel. Zo kan de installateur veilig werken en kan de installatie in geval van nood spanningsvrij worden gemaakt. Ontbreekt deze? Dan moet er een geplaatst worden.

**3. Heb je een 1-fase of 3-fase aansluiting?**

Dit klinkt technisch, maar het is vrij eenvoudig te achterhalen.

**1-fase aansluiting:** Kijk op je energiemeter. Staat er 220V of 230V op? Dan heb je waarschijnlijk een 1-fase aansluiting. Deze is geschikt voor de meeste zonnepanelensystemen tot ongeveer 3.680 Wattpiek (Wp).

**3-fase aansluiting:** Staat er 3x220/230V of 380/400V op de meter? Dan heb je een 3-fase aansluiting (krachtstroom).

Een groter zonnepanelensysteem (meer dan circa 10-12 panelen) produceert vaak meer vermogen dan een 1-fase aansluiting aankan. In dat geval is een upgrade naar een 3-fase aansluiting nodig. Dit regel je via je netbeheerder. Een 3-fase aansluiting verdeelt de stroom beter en is toekomstbestendig, bijvoorbeeld voor een elektrische auto of warmtepomp.

**4. Is je meter slim genoeg?**

Om de teruggeleverde stroom correct te registreren (salderen), heb je een 'slimme meter' of een digitale meter met teruglever-telwerk nodig. Een oude meter met een draaischijf (Ferrarismeter) kan vaak terugdraaien, maar is niet altijd geschikt en zal op termijn vervangen worden. Je kunt bij je netbeheerder de vervanging naar een slimme meter gratis aanvragen.

**Conclusie: Laat het over aan de expert**

Deze checklist geeft je een goed beeld, maar het aanpassen van de meterkast is werk voor een erkend elektricien. Bij Sol-vi.nl zorgen we altijd voor een complete installatie, inclusief de benodigde aanpassingen in de meterkast. Tijdens onze inspectie controleren we alle punten en nemen we de opties met je door, zodat je niet voor verrassingen komt te staan en verzekerd bent van een veilige installatie.`,
    category: "zonnepanelen",
    date: "2025-08-28",
    readTime: 6,
    tags: ["meterkast", "zonnepanelen", "installatie", "veiligheid", "hoofdschakelaar"],
    keywords: ["meterkast zonnepanelen", "meterkast checklist", "zonnepanelen installatie", "hoofdschakelaar", "Elst"],
    author: "SOL-VI Team"
  },
  {
    id: 5,
    slug: "onderhoud-zonnepanelen-tips",
    title: "Haal Alles uit je Dak: Simpele Tips voor het Onderhoud van je Zonnepanelen",
    excerpt: "Zonnepanelen hebben weinig onderhoud nodig, maar met deze simpele tips zorg je ervoor dat ze 25 jaar lang optimaal blijven presteren.",
    content: `Je hebt geïnvesteerd in een prachtig zonnepanelensysteem. De panelen liggen op je dak en je geniet van een lagere energierekening. Maar hoe zorg je ervoor dat ze de komende 25 jaar optimaal blijven presteren? Het goede nieuws: zonnepanelen hebben heel weinig onderhoud nodig. Met een paar simpele tips zorg je ervoor dat je het maximale rendement uit je dak haalt.

**Zijn mijn zonnepanelen zelfreinigend?**

Voor een groot deel wel. Zonnepanelen worden onder een hellingshoek geplaatst. Hierdoor spoelt een flinke regenbui het meeste vuil, zoals stof en zand, er vanzelf af. In een land als Nederland is dit meestal voldoende om de panelen redelijk schoon te houden.

**Wanneer is schoonmaken wel nodig?**

Ondanks de zelfreinigende eigenschappen kan er hardnekkig vuil achterblijven dat het rendement kan verlagen. Denk aan:

**Vogelpoep:** Dit is een van de grootste boosdoeners. Het is hardnekkig en kan, als het lang blijft zitten, de opbrengst van een paneel flink verminderen.

**Fijnstof en roet:** Woon je in de buurt van een drukke weg, industriegebied of een boerderij, dan kan er een dun, plakkerig laagje vuil op je panelen ontstaan dat niet wegspoelt.

**Sahara-zand of bladeren:** Na een storm met zand uit de Sahara of in de herfst kunnen panelen bedekt raken. Meestal spoelt dit vanzelf weg, maar bij langdurige droogte kan het blijven liggen.

Een vuil zonnepaneel kan leiden tot een rendementsverlies van 2% tot wel 10% in extreme gevallen. Een jaarlijkse of tweejaarlijkse schoonmaakbeurt is daarom een slimme zet.

**Hoe maak je zonnepanelen veilig schoon?**

Ga je zelf aan de slag? Veiligheid eerst! Zorg dat je stabiel staat en werk nooit alleen. Volg deze stappen:

**Schakel het systeem uit:** Veiligheid voor alles. Schakel de omvormer en de betreffende groep in de meterkast uit.

**Kies het juiste moment:** Maak schoon op een bewolkte dag of vroeg in de ochtend. Als de panelen heet zijn door de zon, kan koud water thermische schokken veroorzaken en verdampt het water te snel, wat vlekken achterlaat.

**Gebruik de juiste materialen:**
- **Water:** Gebruik osmosewater (water zonder kalk en mineralen) of regenwater. Kraanwater laat kalkvlekken achter die het rendement kunnen verlagen.
- **Gereedschap:** Gebruik een zachte spons, een zachte doek of een telescoopwisser met een zachte borstel.
- **GEBRUIK NOOIT:** Schuurmiddelen, schuursponzen, een hogedrukreiniger of agressieve schoonmaakmiddelen. Deze kunnen de beschermende coating van de panelen onherstelbaar beschadigen.

**Werk van boven naar beneden:** Spoel de panelen eerst af, was ze voorzichtig met de zachte borstel of spons en spoel ze daarna weer goed na.

Twijfel je over de veiligheid of heb je er geen tijd voor? Schakel dan een professioneel schoonmaakbedrijf in.

**Monitoren is de sleutel**

De beste onderhoudstip is misschien wel de simpelste: houd je opbrengst in de gaten! Via de app van je omvormer kun je precies zien hoeveel energie je systeem opwekt. Zie je een onverklaarbare, plotselinge daling in de opbrengst? Dan kan dit duiden op een defect of extreme vervuiling.

Door je systeem in de gaten te houden en af en toe (visueel) te inspecteren, zorg je ervoor dat jouw zonne-energiecentrale jarenlang topprestaties levert.`,
    category: "zonnepanelen",
    date: "2025-08-27",
    readTime: 6,
    tags: ["onderhoud", "zonnepanelen", "schoonmaken", "rendement", "monitoring"],
    keywords: ["zonnepanelen onderhoud", "zonnepanelen schoonmaken", "zonnepanelen rendement", "onderhoud tips", "Elst"],
    author: "SOL-VI Team"
  },
  {
    id: 6,
    slug: "zonnepanelen-toekomst-salderingsregeling",
    title: "Zonnepanelen zonder Salderen: Waarom Investeren in 2025 Nog Steeds Slim Is",
    excerpt: "De salderingsregeling verdwijnt geleidelijk, maar zonnepanelen blijven een topinvestering. Ontdek waarom en hoe je je kunt voorbereiden op de toekomst.",
    content: `De salderingsregeling: het is jarenlang dé gouden reden geweest om te investeren in zonnepanelen. De stroom die je teruglevert, wegstrepen tegen de stroom die je verbruikt. Simpel en zeer voordelig. Nu de overheid plannen heeft om deze regeling in de toekomst af te bouwen, vragen veel mensen zich af: zijn zonnepanelen nog wel rendabel? Het antwoord is een volmondig ja. Sterker nog, het energiesysteem van de toekomst biedt nieuwe, slimme kansen.

**Wat betekent de afbouw van de salderingsregeling?**

De afbouw betekent dat je niet meer 100% van de teruggeleverde stroom mag wegstrepen tegen je verbruik. Voor de stroom die je aan het net levert, ontvang je een 'terugleververgoeding' van je energieleverancier. Deze vergoeding is lager dan de prijs die je betaalt voor de stroom die je afneemt.

De conclusie is simpel: het wordt financieel aantrekkelijker om de zonnestroom die je opwekt, direct zelf te verbruiken.

**Drie redenen waarom zonnepanelen een topinvestering blijven**

**1. Je eigen stroom is de goedkoopste stroom**

Elke kilowattuur (kWh) die je opwekt én direct zelf verbruikt, is een kWh die je niet hoeft te kopen van het energiebedrijf. Met de huidige en verwachte energieprijzen is deze directe besparing de belangrijkste factor voor je rendement. Zelfs zonder salderen bespaar je dus direct fors op je energierekening. Het doel verschuift van 'het net als batterij gebruiken' naar 'zoveel mogelijk eigen stroom verbruiken'.

**Tip:** Zet je wasmachine, vaatwasser of droger aan op het moment dat de zon volop schijnt. Zo maximaliseer je je eigen verbruik.

**2. De opkomst van de thuisbatterij**

De thuisbatterij is de perfecte partner voor je zonnepanelen in een toekomst zonder salderen. Een batterij slaat de overtollige zonnestroom die je overdag opwekt, op. 's Avonds, als de zon onder is en je stroom nodig hebt, gebruik je de gratis opgeslagen energie uit je batterij in plaats van dure stroom van het net te kopen.

Hoewel de investering nu nog aanzienlijk is, worden thuisbatterijen steeds betaalbaarder en efficiënter. Ze maken je nóg onafhankelijker van het elektriciteitsnet en verhogen je 'zelfconsumptie' aanzienlijk.

**3. Dynamische energiecontracten en slimme aansturing**

Met een dynamisch energiecontract is de prijs voor stroom niet vast, maar verandert deze per uur. Op momenten dat er veel zon en wind is, kan de stroomprijs heel laag of zelfs negatief zijn. Wanneer er weinig aanbod is, is de prijs hoger.

Hier liggen enorme kansen voor bezitters van zonnepanelen en een thuisbatterij. Je kunt je batterij opladen als de stroom gratis is en deze energie gebruiken (of zelfs verkopen) als de prijs hoog is. Slimme software kan dit proces volledig automatiseren, zodat je altijd profiteert van de meest gunstige tarieven.

**Conclusie: Een investering in de toekomst**

De focus verschuift, maar de conclusie blijft hetzelfde: investeren in zonnepanelen is een van de slimste financiële beslissingen die je kunt nemen voor je woning. De directe besparing op je energierekening blijft de kern van de terugverdientijd. De combinatie met een thuisbatterij en slimme software maakt je niet alleen minder afhankelijk, maar ook een actieve, slimme speler in de energiemarkt van de toekomst.

Bij Sol-vi.nl denken we graag met je mee over een toekomstbestendige installatie die perfect is afgestemd op jouw wensen. Neem vandaag nog contact op voor een vrijblijvend advies.`,
    category: "zonnepanelen",
    date: "2025-08-26",
    readTime: 8,
    tags: ["salderingsregeling", "zonnepanelen", "thuisbatterij", "dynamische tarieven", "toekomst"],
    keywords: ["salderingsregeling afbouw", "zonnepanelen 2025", "thuisbatterij", "dynamische energiecontracten", "Elst"],
    author: "SOL-VI Team"
  },
  {
    id: 7,
    slug: "zonne-energie-nederland-trends-2025",
    title: "Zonne-energie in Nederland: Een Actueel Overzicht",
    excerpt: "De Nederlandse zonne-energiemarkt in beweging: trends, salderingsregeling en wat de toekomst brengt voor huishoudens.",
    content: `# Zonne-energie in Nederland: Actuele Trends

De Nederlandse zonne-energiemarkt is voortdurend in beweging, gedreven door technologische vooruitgang, overheidsbeleid en veranderende energieprijzen. Deze analyse visualiseert de meest recente ontwikkelingen en biedt inzicht in wat de toekomst in petto heeft voor huishoudens met zonnepanelen.

## Spectaculaire Groei, Maar Nu Stabilisatie

Na jaren van ongekende groei, waarin Nederland zich ontpopte tot wereldleider in zonne-energie per hoofd van de bevolking, zien we nu een vertraging in de verkoop van nieuwe panelen. Desondanks blijft de totale geïnstalleerde capaciteit gestaag toenemen.

De cijfers spreken voor zich: van 1,7 GWp in 2019 naar een piek van 5,0 GWp in 2023, gevolgd door een daling naar 3,4 GWp in 2024. Deze normalisatie was verwacht na de extreme groei van voorgaande jaren.

## De Impact van de Salderingsregeling

De politieke discussie over de salderingsregeling heeft voor onzekerheid gezorgd. Het plan om de regeling af te bouwen is van de baan, maar per 1 januari 2027 stopt de regeling. Dit heeft directe financiële gevolgen voor de terugverdientijd van je investering.

### Scenario's voor Terugverdientijd:

**Huidige Salderingsregeling (tot 2027)**: Terugverdientijd van 6-8 jaar. Je betaalt alleen voor de netto stroomafname.

**Na 2027 (zonder salderen)**: Terugverdientijd kan oplopen tot 15-20 jaar. Je krijgt alleen een lagere terugleververgoeding voor overtollige stroom.

**Na 2027 (met thuisbatterij)**: Terugverdientijd verbetert aanzienlijk door eigen verbruik te maximaliseren. Een thuisbatterij kan de terugverdientijd verkorten naar 10-12 jaar.

## Optimaliseer je Zonne-energie: Zelfverbruik!

Met het aflopen van de salderingsregeling wordt het direct gebruiken van je eigen opgewekte stroom steeds belangrijker. Door je verbruik te plannen, bespaar je meer en verminder je de belasting op het elektriciteitsnet.

Een gemiddeld huishouden met zonnepanelen heeft ongeveer:
- 35% direct eigen verbruik
- 45% teruglevering aan het net  
- 20% verbruik van het net

Door slimme planning kun je het eigen verbruik verhogen en zo beter voorbereid zijn op de toekomst zonder saldering.

## De Toekomst van Zonnepanelen

Ondanks de beleidsveranderingen blijven zonnepanelen een slimme investering, zeker gezien de dalende prijzen. De focus verschuift naar het optimaliseren van zelfverbruik en het overwegen van aanvullende technologieën zoals thuisbatterijen. 

De zonne-energietransitie is een marathon, geen sprint, en de Nederlandse consument blijft een cruciale rol spelen. Bij Sol-vi.nl denken we graag met je mee over een toekomstbestendige installatie.`,
    category: "trends",
    date: "2025-08-31",
    readTime: 5,
    tags: ["trends", "saldering", "thuisbatterij", "toekomst", "rendement"],
    keywords: ["zonne-energie Nederland", "salderingsregeling", "trends 2025", "thuisbatterij", "Elst"],
    author: "SOL-VI Team",
    featured: true,
    imageUrl: "/lovable-uploads/815db32a-8762-4c66-aa95-d00500f2f887.png",
    component: "SolarEnergyInfographic"
  }
];